import filePreviewPdfTemplate from './file-preview-pdf.html';

const backingScale = (canvas, $window) => {
  const ctx = canvas.getContext('2d');
  const dpr = $window.devicePixelRatio || 1;
  const bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
  return dpr / bsr;
};

const setCanvasDimensions = (canvas, w, h, $window) => {
  const ratio = backingScale(canvas, $window);
  canvas.width = Math.floor(w * ratio);
  canvas.height = Math.floor(h * ratio);
  canvas.style.width = `${Math.floor(w)}px`;
  canvas.style.height = `${Math.floor(h)}px`;
  canvas.style.display = 'block';
  canvas.style.margin = '0 auto';
  canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);
  return canvas;
};

@Inject('$document', '$element', '$window', '$scope')
class FilePreviewPdfController {

  $onInit() {
    this.isLoading = true;
    this.renderTask = null;
    this.pdfLoaderTask = null;
    this.url = this.pdfUrl;
    this.pdfDoc = null;
    this.pageToDisplay = isFinite(this.page) ? parseInt(this.page) : 1;
    this.pageFit = true;
    this.scale = 1;
    this.canvas = this.$document[0].createElement('canvas');
    this.scroll = 0;
    this.$document[0].getElementById('pdf-canvas').append(this.canvas);

    PDFJS.disableWorker = true;

    this.ctx = this.canvas.getContext('2d');
    const windowEl = angular.element(this.$window);

    windowEl.on('scroll', () => {
      this.scroll = windowEl[0].scrollY;
    });

    this.pageNum = this.pageToDisplay;

    if (this.pdfDoc !== null) {
      this.renderPage(this.pageToDisplay);
    }

    if (this.pdfLoaderTask) {
      this.pdfLoaderTask.destroy().then(() => {
        this.renderPdf();
      });
    } else {
      this.renderPdf();
    }

    this.disableZoomInBrowser();
  }

  $onDestroy() {
    this.enableZoomInBrowser();
  }

  disableZoomInBrowser() {
    this.$document.bind('keydown', (event) => {
      if (event.ctrlKey == true && (event.which == '61' || event.which == '107' || event.which == '173' || event.which == '109'  || event.which == '187'  || event.which == '189'  ) ) {
        event.preventDefault();
        if (event.which == '107' || event.which == '61' || event.which == '187') {
          this.zoomIn();
        } else if (event.which == '109' || event.which == '173' || event.which == '189') {
          this.zoomOut();
        }
      }
    });

    angular.element(this.$window).bind('mousewheel DOMMouseScroll', (event) => {
      if (event.ctrlKey == true) {
        event.preventDefault();
        if (event.originalEvent) {
          if (event.originalEvent.deltaY < 0) {
            this.zoomIn();
          } else if (event.originalEvent.deltaY > 0) {
            this.zoomOut();
          }
        }
      }
    });
  }

  enableZoomInBrowser() {
    this.$document.unbind('keydown');
    angular.element(this.$window).unbind('mousewheel DOMMouseScroll');
  }

  renderPage(pageNum) {
    if (this.renderTask) {
      this.renderTask._internalRenderTask.cancel();
    }

    this.pdfDoc.getPage(pageNum).then((page) => {
      let viewport;
      let pageWidthScale;
      let renderContext;

      if (this.pageFit) {
        viewport = page.getViewport(1);
        const clientRect = this.$element[0].getBoundingClientRect();
        pageWidthScale = clientRect.width / viewport.width;
        this.scale = pageWidthScale;
      }

      viewport = page.getViewport(this.scale);

      setCanvasDimensions(this.canvas, viewport.width, viewport.height, this.$window);

      renderContext = {
        canvasContext: this.ctx,
        viewport,
      };

      this.renderTask = page.render(renderContext);
    });
  }

  goToPage() {
    this.renderPage(parseInt(this.pageNum));
  }

  goPrevious() {
    if (this.pageToDisplay <= 1) {
      return;
    }
    this.pageToDisplay = parseInt(this.pageToDisplay) - 1;
    this.pageNum = this.pageToDisplay;
    this.renderPage(this.pageToDisplay);
  }

  goNext() {
    if (this.pageToDisplay >= this.pdfDoc.numPages) {
      return;
    }
    this.pageToDisplay = parseInt(this.pageToDisplay) + 1;
    this.pageNum = this.pageToDisplay;
    this.renderPage(this.pageToDisplay);
  }

  zoomIn() {
    this.pageFit = false;
    this.scale = parseFloat(this.scale) + 0.2;
    this.renderPage(this.pageToDisplay);
  }

  zoomOut() {
    this.pageFit = false;
    this.scale = parseFloat(this.scale) - 0.2;
    this.renderPage(this.pageToDisplay);
  }

  fit() {
    this.pageFit = true;
    this.renderPage(parseInt(this.pageNum));
  }

  clearCanvas() {
    if (this.ctx) {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
  }

  renderPdf() {
    this.clearCanvas();

    const params = {
      url: this.url,
      withCredentials: true,
      httpHeaders: {
        Authorization: `Bearer ${this.credentials}`,
        'Access-Control-Allow-Headers': 'Range',
        'Access-Control-Expose-Headers': 'Accept-Ranges, Content-Encoding, Content-Length, Content-Range',
      },
    };

    if (this.url && this.url.length) {
      this.pdfLoaderTask = PDFJS.getDocument(params);
      this.pdfLoaderTask.then((_pdfDoc) => {
        this.isLoading = false;
        this.pdfDoc = _pdfDoc;
        this.renderPage(this.pageToDisplay);
        this.$scope.$apply(() => {
          this.pageCount = _pdfDoc.numPages;
        });
      });
    }
  }
}

export default class FilePreviewPdfComponent {
  constructor() {
    this.template = filePreviewPdfTemplate;
    this.controller = FilePreviewPdfController;
    this.bindings = {
      pdfUrl: '<',
      page: '<',
      credentials: '<',
      fileName: '<',
      hidePreview: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/file-preview/components/file-preview-pdf/file-preview-pdf-component.js